<template>
  <label :title="title">
    <svg class="alert-icon" xmlns="http://www.w3.org/2000/svg" width="25.409" height="25.409" viewBox="0 0 25.409 25.409">
      <g transform="translate(-2 -2)">
        <path d="M26.409,14.7A11.7,11.7,0,1,1,14.7,3a11.7,11.7,0,0,1,11.7,11.7Z" transform="translate(0 0)"/>
        <path d="M18,12v4.682" transform="translate(-3.295 -1.977)"/>
        <path d="M18,24h0" transform="translate(-3.295 -4.614)"/>
      </g>
    </svg>
  </label>
</template>

<script>
export default {
  name: 'alert-icon',
  props: {
    title: String
  }
}
</script>

<style>
.alert-icon > g > path {
  fill: none;
  stroke: #ed2559;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
